import { LucideIcon } from 'lucide-react'

interface EmptyStateProps {
  icon: LucideIcon
  title: string
  description?: string
}

export function EmptyState({
  icon: Icon,
  title,
  description,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-10 px-6 text-center">
      <div className="relative mb-4">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-toast/20 rounded-full blur-xl" />
        <div className="relative rounded-2xl bg-gradient-to-br from-primary/10 to-toast/10 p-4">
          <Icon size={28} className="text-primary" />
        </div>
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-1.5">{title}</h3>
      {description && (
        <p className="text-sm text-muted-foreground max-w-sm leading-relaxed">
          {description}
        </p>
      )}
    </div>
  )
}
